export default {
  defaultProps: {
    TransitionProps: {
      mountOnEnter: true,
      unmountOnExit: true,
    },
  },
};
